import { Controller } from '@hotwired/stimulus'
import openModal from '../utils/modal'
import * as analytics from '../utils/analytics'

export default class extends Controller {
  static get targets () {
    return ['form', 'postcode', 'result']
  }

  static values = { brandName: String, productName: String }

  fetch (event) {
    event.preventDefault()

    this.track()

    openModal({ url: this.url(), slug: this.slug(), behavior: 'drawer', variant: 'small' })
  }

  url () {
    const url = new URL(this.formTarget.action)
    url.searchParams.set('layout', false)
    url.searchParams.set('postcode', this.postcode())
    return url.toString()
  }

  postcode () {
    const basePostcode = this.postcodeTarget.value

    return basePostcode.toUpperCase().replace(/\s+/g, '')
  }

  slug () {
    return this.element.dataset.slug.toLowerCase()
  }

  track () {
    analytics.track('recycling_lookup', {
      eventAction: this.productNameValue,
      eventLabel: `${this.brandNameValue} / ${this.productNameValue}`
    })
    analytics.track('recycling_lookup', {
      object: 'recycling',
      action: 'lookup',
      subject_name: this.productNameValue,
      brand_name: this.brandNameValue
    }, { adapter: 'segment' })
  }
}
